import { useState } from 'react'

import { Select } from 'antd'
import ModalComponent from 'components/ModalComponent'

import styles from './styles.module.scss'

export default function ExportDataModal({
   onCancel,
   onConfirm,
   titleLabel = 'Data',
   isVisible,
   setIsVisible,
}: {
   onCancel?: () => void
   onConfirm?: (data: any) => void
   isVisible: boolean
   setIsVisible: (isVisible: boolean) => void
   titleLabel?: string
}) {
   const [format, setFormat] = useState('xlsx')

   const handelConfirm = () => {
      onConfirm?.(format)
      setIsVisible(false)
   }
   return (
      <ModalComponent
         isVisible={isVisible}
         centered
         setIsVisible={setIsVisible}
         title={`Export ${titleLabel}`}
         modalClassName={styles.modalDriver}
      >
         <div className={styles.container}>
            <div className={styles.selectDriver}>
               <div className={styles.title}>Select the format</div>
               <Select
                  showSearch
                  className={styles.select}
                  placeholder="Select format"
                  style={{ marginTop: '10px', width: '100%' }}
                  options={[
                     {
                        value: 'xlsx',
                        label: 'Excel (xlsx)',
                     },
                     {
                        value: 'xls',
                        label: 'Excel (xls)',
                     },
                     {
                        value: 'csv',
                        label: 'CSV',
                     },
                     {
                        value: 'pdf',
                        label: 'PDF',
                     },
                  ]}
                  value={format}
                  onChange={(value) => {
                     setFormat(value)
                  }}
                  filterOption={(input, option: any) =>
                     (option?.label?.toLowerCase() ?? '').includes(
                        input.toLowerCase()
                     )
                  }
               />
            </div>
            <div className={styles.btnHolder}>
               <div className={styles.lineBreak} />
               <button className={styles.btnConfirm} onClick={handelConfirm}>
                  Confirm
               </button>
               <button
                  className={styles.btnCancel}
                  onClick={() => {
                     setIsVisible(false)
                     onCancel?.()
                  }}
               >
                  Cancel
               </button>
            </div>
         </div>
      </ModalComponent>
   )
}
